module.exports = __webpack_public_path__ + "media/application/images/icons/bell-cbf49d44e6c62adffcf90c48f9f05cba.svg";